import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLoginComponent } from './login/login.component';
import { AuthLogoutComponent } from './logout/logout.component';
import { ModificaPasswordComponent } from './modifica-password/modifica-password.component';
import { RecuperaPasswordComponent } from './recupera-password/recupera-password.component';
import { RegistrazioneFornitoreComponent } from './registrazione-fornitore/registrazione-fornitore.component';

const routes: Routes = [
  {
    path: 'auth',
    children: [
      { path: 'login', component: AuthLoginComponent },
      { path: 'logout', component: AuthLogoutComponent },
      { path: 'recupera-password', component: RecuperaPasswordComponent },
      { path: 'reset-password/:tkn', component: ModificaPasswordComponent },
      { path: 'registrazione-fornitore', component: RegistrazioneFornitoreComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
